import { MenuProps } from "antd";
import Menu from "./Menu";
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';

type MenuItem = Required<MenuProps>['items'][number];
export default class CusumMenuForSelect {
    title: React.ReactNode;
    value: any;
    key: any;
    children?: any;

    constructor(title: React.ReactNode, key: React.Key, value: React.ReactNode, children?: any){
        this.title = title;
        this.value = value;
        this.key = key;
        this.children = children;
    }

    // Provisoirement
    static getMenu(menus : Array<Menu>) : any{
        var custumMenu : Array<CusumMenuForSelect> = []
        
        var lepere1 : string = ""
        var niveau = 1;

        //Menu
        menus.forEach((menu : Menu) => {
            if(menu.codmen.length == 1 && menu.libelmenfr != "-" ){
                if(menu.lien+"" == ""){
                    lepere1 = menu.codmen.substring(0,niveau)
                    custumMenu.push(new CusumMenuForSelect(menu.libelmenfr.replace("&", ""), menu.codmen, menu.codmen, CusumMenuForSelect.sousMenu(menus, lepere1, niveau+2)))    
                }else{
                    custumMenu.push(new CusumMenuForSelect(menu.libelmenfr.replace("&", ""), menu.codmen, menu.codmen))
                }
            }
        });

        return custumMenu;
    }
    private static sousMenu(menus : Array<Menu>, lepere: string, niveau: number): any{
        var custumMenu : Array<CusumMenuForSelect> = []
        var lepere2 : string = ""

        menus.forEach((menu : Menu) => {
            if(menu.codmen.length == niveau && menu.codmen.substring(0,niveau-2) == lepere && menu.libelmenfr != "-" ){
                if(menu.lien+"" == ""){
                    lepere2 = menu.codmen.substring(0,niveau)
                    custumMenu.push(new CusumMenuForSelect(menu.libelmenfr.replace("&", ""), menu.codmen, menu.codmen, CusumMenuForSelect.sousMenu2(menus, lepere2, niveau+2)))
                }else{
                    custumMenu.push(new CusumMenuForSelect(menu.libelmenfr.replace("&", ""), menu.codmen, menu.codmen))
                }
            }

        });
        return custumMenu;
    }
    private static sousMenu2(menus : Array<Menu>, lepere: string, niveau: number): any{
        var custumMenu : Array<CusumMenuForSelect> = []
        var lepere3 : string = ""

        menus.forEach((menu : Menu) => {
            if(menu.codmen.length == niveau && menu.codmen.substring(0,niveau-2) == lepere && menu.libelmenfr != "-" ){
                if(menu.lien+"" == ""){
                    lepere3 = menu.codmen.substring(0,niveau)
                    custumMenu.push(new CusumMenuForSelect(menu.libelmenfr.replace("&", ""), menu.codmen, menu.codmen, CusumMenuForSelect.sousMenu3(menus, lepere3, niveau+2)))
                }else{
                    custumMenu.push(new CusumMenuForSelect(menu.libelmenfr.replace("&", ""), menu.codmen, menu.codmen))
                }
            }

        });
        return custumMenu;
    }
    
    private static sousMenu3(menus : Array<Menu>, lepere: string, niveau: number): any{
        var custumMenu : Array<CusumMenuForSelect> = []

        menus.forEach((menu : Menu) => {
            if(menu.codmen.length == niveau && menu.codmen.substring(0,niveau-2) == lepere && menu.libelmenfr != "-" ){
                
                custumMenu.push(new CusumMenuForSelect(menu.libelmenfr.replace("&", ""), menu.codmen, menu.codmen))
            }

        });
        return custumMenu;
    }
}